import { useQuery, useMutation } from "@tanstack/react-query";
import { blockVolunteerApiService } from "./blockvolunteer.api";

interface ApiResponse<T = any> {
  data: T;
  message: string;
  statusCode: number;
}

export const useBlockVolunteerService = ({
  searchText = "",
  currentPage = 1,
  pageSize = 10,
  enableSelectAll = false,
  blockid = null,
  studyid = null,
  blocksource = undefined,
}: {
  searchText?: string;
  currentPage?: number;
  pageSize?: number;
  enableSelectAll?: boolean;
  blockid?: number | null;
  studyid?: number | null;
  blocksource?: string | null;
} = {}) => {
  const SelectAllQuery = useQuery({
    queryKey: ["block-volunteer-select-all", searchText, currentPage, pageSize, studyid, blocksource],
    queryFn: () =>
      blockVolunteerApiService.getSelectAllData({
        searchText,
        currentPage,
        pageSize,
        studyid: studyid ? Number(studyid) : null,
        blocksource,
      }),
    enabled: enableSelectAll,
  });

  const SelectQuery = useQuery({
    queryKey: ["block-volunteer-select", blockid],
    queryFn: () => blockVolunteerApiService.getSelectData(Number(blockid)),
    enabled: !!blockid,
  });

  const InsertMutation = useMutation<ApiResponse, Error, any>({
    mutationFn: (payload: any) => blockVolunteerApiService.insertData(payload),
  });

  const UpdateMutation = useMutation<ApiResponse, Error, any>({
    mutationFn: (payload: any) => blockVolunteerApiService.updateData(payload),
  });

  const VerifyMutation = useMutation<ApiResponse, Error, any>({
    mutationFn: (payload: any) => blockVolunteerApiService.verifyData(payload),
  });

  const DeleteMutation = useMutation<ApiResponse, Error, any>({
    mutationFn: (payload: any) => blockVolunteerApiService.deleteData(payload),
  });

  return {
    SelectAllQuery,
    SelectQuery,
    InsertMutation,
    UpdateMutation,
    VerifyMutation,
    DeleteMutation,
  };
};

export const useBlockStatusService = (volunteerId: number | null) => {
  const BlockStatusQuery = useQuery({
    queryKey: ["block-volunteer-status", volunteerId],
    queryFn: () => blockVolunteerApiService.getBlockStatus(Number(volunteerId)),
    enabled: !!volunteerId,
  });

  return { BlockStatusQuery };
};

